<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="security"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns">
                    <div v-if="loading" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loading" class="column is-full">
                        <div class="columns">
                            <div class="column is-3">
                                <div class="plan-page-label">Password</div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Update the password of your Weap.io account.
                                </div>
                            </div>
                            <div class="column is-9" style="padding-left: 60px;">
                                <div class="columns is-multiline">
                                    <div class="column is-half">
                                        <input v-model="inputs.new_password" @keyup.enter="updateUser" type="password" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('new_password') }" placeholder="New password">
                                        <span v-if="hasError('new_password')" class="help is-danger">{{ getError('new_password') }}</span>
                                    </div>
                                    <div class="column is-half">
                                        <input v-model="inputs.new_password_confirmation" @keyup.enter="updateUser" type="password" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('new_password_confirmation') }" placeholder="Confirm new password">
                                        <span v-if="hasError('new_password_confirmation')" class="help is-danger">{{ getError('new_password_confirmation') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <input v-model="inputs.current_password" @keyup.enter="updateUser" type="password" class="input custom-input-size is-medium" :disabled="updatingUser" :class="{ 'is-danger': hasError('current_password') }" placeholder="Current password">
                                        <span v-if="hasError('current_password')" class="help is-danger">{{ getError('current_password') }}</span>
                                    </div>
                                    <div class="column is-full">
                                        <div @click="updateUser" class="button custom-button-size is-fullwidth is-info">Update password</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="column is-full p-bottom-0">
                        <p class="is-size-5 has-text-grey-dark">Account security</p>
                    </div> -->

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Account Security - Weap.io',
    },

    data() {
        return {
            inputs: {
                new_password: null,
                new_password_confirmation: null,
                current_password: null,
            },
            loading: false,
            updatingUser: false,
            allowedInputs: ['new_password', 'new_password_confirmation', 'current_password'],
        }
    },

    methods: {
        updateUser() {
            if (this.updatingUser) {
                return;
            }

            this.resetErrors();
            this.updatingUser = true;

            let endpoint = 'users/' + localStorage.getItem('userId');

            Api().put(endpoint, this.inputs)
                .then((response) => {
                    Swal.fire({
                        title: 'Done!',
                        text: 'Your account password was updated.',
                        type: 'success',
                    });
                    this.resetInputs();
                })
                .catch((error) => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        var message = 'Something wrong happened. Refresh the page and try again.';
                        if (typeof error.response.data.message == 'string') {
                            message = error.response.data.message;
                        }

                        Swal.fire({
                            title: 'Oops',
                            text: message,
                            type: 'error',
                        });
                    }
                })
                .finally(() => {
                    this.updatingUser = false;
                });
        },

        resetInputs() {
            this.inputs.new_password = '';
            this.inputs.new_password_confirmation = '';
            this.inputs.current_password = '';
        },
    },
}
</script>
